import { useFormikContext } from 'formik';
import { isEqual } from 'lodash';
import { FC, useEffect } from 'react';

import { PageProductListingFilters } from 'src/data/Contentful/ContentfulGetPageProductListing.types';

import { PlpFiltersProps } from './PlpFilters.type';

interface Props extends Pick<PlpFiltersProps, 'filters' | 'setFilters' | 'listingOptions'> {}

export const PlpFilterFormObserver: FC<Props> = ({ filters, setFilters, listingOptions }) => {
  const { values } = useFormikContext<PageProductListingFilters>();

  useEffect(() => {
    if (!isEqual(values, filters)) {
      setFilters(values, { ...listingOptions, page: '1' });
    }
  }, [values]);

  return null;
};
